import state from '@/store/state'

let winWidth = null
let resizeHandle = () => {
  winWidth = document.documentElement.clientWidth || window.innerWidth
  state.navCtrl = winWidth < 1200
}

resizeHandle()
window.addEventListener('resize', resizeHandle)
